<template>
  <div class="layout my-contacts">
    <div class="tab_nav">
      <div class="nav_item" :class="{ is_active: index == actIndex }" @click="tabChange(index)" v-for="(item, index) in navList" :key="index">{{ item }}</div>
    </div>
    <div class="tab_content">
      <contactReplay v-if="actIndex == 0"></contactReplay>
      <contactMe v-if="actIndex == 1"></contactMe>
      <myContact v-if="actIndex == 2"></myContact>
      <contactList v-if="actIndex == 3"></contactList>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import contactMe from "./components/contact-me"; //联系我的
import myContact from "./components/my-contact"; //我联系的
import contactList from "./components/contact-list"; //行业人脉
import contactReplay from "./components/contact-replay"; // 已回应
export default {
  name: "my-contacts",
  components: {
    contactMe,
    myContact,
    contactList,
    contactReplay,
  },
  data() {
    return {
      actIndex: 0,
      navList: ["已回应", "联系我的", "我联系的", "行业人脉"],
    };
  },
  async created() {
    this.$store.commit("setExhibitionId", this.$route.params.id);
    if (!this.userInfo) {
      await this.$Myapollo.getUserInfo(this);
    }
    this.actIndex = this.myContactsHead;
  },
  mounted() {},
  computed: {
    ...mapGetters({
      myContactsHead: "getMyContactsHead",
      userInfo: "getUserInfo",
    }),
  },
  methods: {
    tabChange(i) {
      if (this.actIndex == i) {
        return;
      }
      this.actIndex = i;
      this.$store.commit("setMyContactsHead", i);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-contacts {
  background: #f2f2f2;
  padding: 0.9rem 0 0;
  .tab_nav {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 0.9rem;
    width: 100%;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.45rem;
    border-bottom: 1px solid #e6e6e6;
    .nav_item {
      color: #666;
      width: 2rem;
      height: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.48rem;
      font-size: 0.26rem;
      &.is_active {
        color: #fff;
        background: #1890ff;
      }
    }
  }
  .tab_content {
    padding: 0.3rem;
  }
}
</style>
